// ============================================================
// Staff Enums & Constants
// ============================================================

export const EmploymentStatus = {
  ACTIVE: 'ACTIVE',
  ON_LEAVE: 'ON_LEAVE',
  SUSPENDED: 'SUSPENDED',
  RESIGNED: 'RESIGNED',
  TERMINATED: 'TERMINATED',
};

export const EMPLOYMENT_STATUS_OPTIONS = [
  { value: EmploymentStatus.ACTIVE, label: 'Active', color: 'success' },
  { value: EmploymentStatus.ON_LEAVE, label: 'On Leave', color: 'warning' },
  { value: EmploymentStatus.SUSPENDED, label: 'Suspended', color: 'error' },
  { value: EmploymentStatus.RESIGNED, label: 'Resigned', color: 'default' },
  { value: EmploymentStatus.TERMINATED, label: 'Terminated', color: 'error' },
];
